import { record, z } from 'zod/v4'
import {
  type ApiHydraResponse,
} from '@services/api/declarations'

import { UserProfileSchema } from '@services/User/declarations'

// ***
// BASE SCHEMAS
// ***

const UserTokenSchema = z.object({
  token: z.jwt(),
  token_ttl: z.number(),
})

// ***
// REQUEST SCHEMAS
// ***

export const CreateUserTokenRequestSchema = z.object({
  data: z.object({
    username: z.string().trim().toLowerCase(),
    password: z.string(),
  }),
})

export const RefreshUserTokenRequestSchema = z.record(z.string(), z.unknown())

// ***
// RESPONSE SCHEMAS
// ***

export const CreateUserTokenSchema = UserTokenSchema
export const RefreshUserTokenSchema = UserTokenSchema

// ***
// STORAGE SCHEMAS
// ***

export const LocalStorageAuthSchema = z.object({
  auth: z.object({
    token: z.jwt(),
    userIdentifier: z.string(),
    refreshTokenValidity: z.number().optional(),
    tokenTtl: z.number().optional(),
  }),
  currentProfile: UserProfileSchema.partial().optional(),
  keepLoggedIn: z.boolean().optional(),
})

// ***
// EXPORTED TYPES
// ***

export type CreateUserTokenRequest = z.infer<typeof CreateUserTokenRequestSchema>
export type RefreshUserTokenRequest = z.infer<typeof RefreshUserTokenRequestSchema>
export type CreateUserToken = z.infer<typeof CreateUserTokenSchema>
export type RefreshUserToken = z.infer<typeof RefreshUserTokenSchema>
export type LocalStorageAuth = z.infer<typeof LocalStorageAuthSchema>

// ***
// STORE
// ***

export interface ApiAuthStoreShape {
  postCreateUserToken?: ApiHydraResponse<CreateUserToken>,
  postRefreshToken?: ApiHydraResponse<RefreshUserToken>,
}
